import { ArrowDown } from '@components/icons';
import { TimeSlot } from 'server/types/cal-overrides';
import { summarizeAvailability } from 'shared/scheduling';

export type Props = {
  label: string;
  isDefault?: boolean;
  scheduleTimeZone: string;
  renderTimeZone: string;
  timeslots: TimeSlot[];
};

export function SummarizeAvailableTimes(
  props: Pick<Props, 'timeslots' | 'renderTimeZone' | 'scheduleTimeZone'>,
) {
  const availability = summarizeAvailability({
    timeslots: props.timeslots,
    hour12: true,
    scheduleTimeZone: props.scheduleTimeZone,
    renderTimeZone: props.renderTimeZone,
  });
  return (
    <span class="flex flex-col gap-2">
      {availability.map((x) => (
        <span key={`${x.days}-${x.times}`} class="flex gap-2">
          <span>{x.days}</span> <span>{x.times}</span> ({props.renderTimeZone})
        </span>
      ))}
    </span>
  );
}

export function PreviewAvailableTimesChange(
  props: Pick<Props, 'timeslots' | 'renderTimeZone' | 'scheduleTimeZone'>,
) {
  const availability = summarizeAvailability({
    timeslots: props.timeslots,
    hour12: true,
    scheduleTimeZone: props.scheduleTimeZone,
    renderTimeZone: props.renderTimeZone,
  });

  return (
    <div className="space-y-3">
      {availability.map((x) => (
        <div key={`${x.days}-${x.times}`} className="rounded-lg bg-gray-50 p-4">
          <div className="text-sm font-semibold text-gray-700">{x.days}</div>

          <div className="mt-2 flex flex-col items-start gap-2 text-sm">
            <div className="flex items-center text-gray-700">
              <span className="font-medium">{x.times}</span>
              <span className="ms-2 text-gray-500">({props.renderTimeZone})</span>
            </div>

            <div className="flex items-center text-gray-400">
              <ArrowDown className="h-4 w-4" />
            </div>

            <div className="flex items-center text-blue-600">
              <span className="font-medium">{x.times}</span>
              <span className="ms-2 text-gray-500">({props.scheduleTimeZone})</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
